import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import "./signin.css";
import shop_logo from "../../images/splash/shop_logo.jpeg";
import axios from "axios";
import Swal from 'sweetalert2';
import { var_api } from "../constant";
import { Card, CardTitle, CardSubtitle, CardBody,Tooltip } from 'reactstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import "bootstrap/dist/css/bootstrap.min.css";
import sage from '../../images/splash/sage.jpeg';
import Loader from '../ServiceBooking/Loader';

const SignIn = () => {
  const history = useHistory();
  const handleSignupClick = () => {
    history.push('/signup');
  };
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userId, setUserId] = useState('');
  const [isLogin, setIsLogin] = useState(false);
  const [showPassword, setShowPassword] = useState(false); 
  const [tooltipOpen, setTooltipOpen] = useState(false);


  // // Check if userId is available in localStorage when the component mounts
  // useEffect(() => {
  //   const storedUserId = localStorage.getItem('userId');
  //   if (storedUserId) {
  //     setUserId(storedUserId);
  //     history.push('/home');
      
  //   }
  // }, [history]);


  //check token and clear it
  useEffect(() => {
    localStorage.removeItem('token');
   console.log('tok',  localStorage.getItem('token'));
  },[]);



  const Submit = async (e) => {
    e.preventDefault();
    setIsLogin(true);
  
    try {
      const response = await axios.post(`${var_api}/api/user/signin`, {
        email: email,
        password: password,
      });
     
      setUserId(response.data.id); 
     
      if (response.status === 200) {
        // Assuming 'id' is the variable containing the ID you want to save
        const id = response.data.id; // Replace 'data.id' with the actual property path containing the ID in the response
        const mailid =  response.data.mailId //Replace 'data.mailId with the actual property path containing the Email in the response
        const admin_employee = response.data.admin_employee;
    
        // Save the ID in local storage
        localStorage.setItem('userId', id);
    
         // Save the EMAILID in local storage
         localStorage.setItem('emailId', mailid);

          // Save the admin employee id in local storage
          localStorage.setItem('admin_employee', admin_employee);

        
        // Redirect the user to the '/home' page
        history.push('/');
        setIsLogin(false);
    }
    
      console.log('Login successful!');
      // Handle success scenario as needed
    } catch (error) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        // Show the Swal alert for a Bad Request (status code 400)
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Invalid username or password...',
          confirmButtonColor: '#007500',
        });
        setIsLogin(false);
      }
      setIsLogin(false);
      // Handle error scenario as needed
    }
  };

  const handleGoSuperAdmin = () => {
    history.push('/admin');
  }


  const handleGohome = () => {
    history.push('/sb-home');
  }

  const handleGoToForgotPassword = () => {
    history.push('/forgot-password');
    localStorage.setItem("passwordFor","Admin");
  }


  const handleGoToEmpForgotPassword = () => {
    history.push('/forgot-password');
    localStorage.setItem("passwordFor","Employee");
  }

  const toggleTooltip = () => {
    setTooltipOpen(!tooltipOpen);
  };


  const EmpSubmit = async (e) => {
    e.preventDefault();
    setIsLogin(true);
  
    try {
      const response = await axios.post(`${var_api}/api/employees/signin`, {
        e_email: email,
        e_password: password,
      });
     
      setUserId(response.data.id); 
     
      if (response.status === 200) {
        //Assuming 'id' is the variable containing the ID you want to save
        const id = response.data.employeeDetails.user_id; // Replace 'data.id' with the actual property path containing the ID in the response
        const mailid =  response.data.employeeDetails.e_email; //Replace 'data.mailId with the actual property path containing the Email in the response
        const admin_employee = response.data.employeeDetails.id;
        const sub_status = response.data.sub_status;
        const verification_status = response.data.verification_status;
        const e_role = response.data.employeeDetails.e_role;
        const e_name = response.data.employeeDetails.e_name;
    
        // Save the ID in local storage
        localStorage.setItem('userId', id);
    
         // Save the EMAILID in local storage
         localStorage.setItem('empEmailId', mailid);

         localStorage.setItem('empId', admin_employee);

          // Save the admin employee id in local storage
          // localStorage.setItem('admin_employee', admin_employee);
          localStorage.setItem('sub_status', sub_status);
          localStorage.setItem('verification_status',verification_status)
          localStorage.setItem('e_role',e_role);
          localStorage.setItem('empName',e_name);
          const sub_statusl = localStorage.getItem("sub_status");
          const verification_statusl = localStorage.getItem("verification_status");
          console.log("s,v",sub_statusl,verification_statusl);

        
        // Redirect the user to the '/home' page
        history.push('/');
        setIsLogin(false);
    }
    
      console.log('Login successful!');
      // Handle success scenario as needed
    } catch (error) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        // Show the Swal alert for a Bad Request (status code 400)
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Invalid username or password...',
          confirmButtonColor: 'rgba(103,120,95,1)',
        });
        setIsLogin(false);
      }
      setIsLogin(false);
      // Handle error scenario as needed
    }
  }


  const adminemplogin = async (e) => {
    e.preventDefault();
    setIsLogin(true);
  
    try {
      const response = await axios.post(`${var_api}/api/admin-emp/signin`, {
        email: email,
        password: password,
      });
  
      setUserId(response.data.id); 
  
      if (response.status === 200) {
        // Redirect the user to the '/home' page
        await login(); // Call login after successful adminemplogin
        setIsLogin(false);
      }
  
      console.log('Login successful!');
      // Handle success scenario as needed
    } catch (error) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        // Show the Swal alert for a Bad Request (status code 400)
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Invalid username or password...',
          confirmButtonColor: 'rgba(103,120,95,1)',
        });
        setIsLogin(false);
      }
      setIsLogin(false);
      // Handle error scenario as needed
    }
  }
  
  const login = async () => {
    setIsLogin(true);
    try {
      const response = await axios.post(`${var_api}/api/emp/signin`, {
        email: email,
        password: password,
      });
  
      setUserId(response.data.id);
  
      if (response.status === 200) {
        const userId = response.data.id;
        const mailid = response.data.mailId;
        const token = response.data.token;
        const role = response.data.role;

        localStorage.setItem('role', role);
        localStorage.setItem('userId', userId);
        localStorage.setItem('empEmailId', mailid);
        localStorage.setItem('token', token);
  
        console.log('Employee login successful, calling loginput...');
        await loginput(mailid, token, userId); // Call loginput with necessary parameters
        setIsLogin(false);
      }
    } catch (error) {
      console.error('Employee login error:', error);
      if (error.response && error.response.status === 401) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Invalid username or password...',
          confirmButtonColor: 'rgba(103,120,95,1)',
        });
      }
      setIsLogin(false);
    }
  }
  
  const loginput = async (mailid, token, userId) => {
    setIsLogin(true);
    try {
      const response = await axios.put(`${var_api}/api/user-access/update-token/${userId}/${mailid}`, {
        token: token
      });
  
      if (response.status === 200) {
        console.log('Token update successful!');
        handleGohome();
        setIsLogin(false);
      }
  
      console.log('Log input successful!');
    } catch (error) {
      console.error('Log input error:', error);
      if (error.response && error.response.status === 401) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Invalid username or password...',
          confirmButtonColor: 'rgba(103,120,95,1)',
        });
      }
      setIsLogin(false);
    }
  }
  

   
  return (
    <>
     {isLogin && <Loader />}
   <div className="auth-wrapper">
          <div className="auth-inner">
          <form onSubmit={adminemplogin}>
            <div className="text-center">
            <img src={sage} alt="logo" style={{width:"100px", height:"100px",border:"3px solid rgba(103,120,95,1)", borderRadius:"50px", padding:"5px"}} />
            </div>
        <h3 className="mt-3">Sign In</h3>
        <div className="mb-3">
          <label>Email</label>
          <input
            type="email"
            className="form-control"
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
            <label>Password</label>
            <div className="input-group" style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                id="signinpassword"
                required
              />
                <button
          className="btn btn-outline-secondary" 
          type="button"  id="signinshow"
          onClick={() => setShowPassword(!showPassword)} // Toggle showPassword state on button click
        >
          {showPassword ? <i class="bi bi-eye-slash-fill" id="signineye"></i> :  <i class="bi bi-eye-fill" id="signineye"></i>} {/* Show eye icon based on showPassword state */}
        </button>
        </div>
            </div>
        {/* <div className="mb-3">
          <div className="custom-control custom-checkbox">
          <p className="forgot-password text-right fw-bold">
          Forgot <a href="/admin-forgot-password" style={{color:"rgba(103,120,95,1)",fontWeight:"bolder"}}>password?</a>
        </p>
          </div>
        </div> */}
        <br/>
        <div className="d-grid">
          <button type="submit" className="btn btn-primary" style={{backgroundColor:"rgba(103,120,95,1)", borderColor:"rgba(103,120,95,1)"}} 
          // onClick={handleGohome} 
          // onClick={adminemplogin}
          >
            SUBMIT
          </button>
        </div>
       
      </form>
          </div>
        </div>
    </>
  );
};

export default SignIn;






// import React, { useState, useEffect } from "react";
// import { Link, useHistory } from "react-router-dom";
// import "./signin.css";
// import shop_logo from "../../images/splash/shop_logo.jpeg";
// import axios from "axios";
// import Swal from 'sweetalert2';
// import { var_api } from "../constant";
// import { Card, CardTitle, CardSubtitle, CardBody,Tooltip } from 'reactstrap';
// import Tab from 'react-bootstrap/Tab';
// import Tabs from 'react-bootstrap/Tabs';
// import "bootstrap/dist/css/bootstrap.min.css";
// import sage from '../../images/splash/sage.jpeg';

// const SignIn = () => {
//   const history = useHistory();
//   const handleSignupClick = () => {
//     history.push('/signup');
//   };
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [userId, setUserId] = useState('');
//   const [isLogin, setIsLogin] = useState(false);
//   const [showPassword, setShowPassword] = useState(false); 
//   const [tooltipOpen, setTooltipOpen] = useState(false);

//   const Submit = async (e) => {
//     e.preventDefault();
//     setIsLogin(true);
  
//     try {
//       const response = await axios.post(`${var_api}/api/user/signin`, {
//         email: email,
//         password: password,
//       });
     
//       setUserId(response.data.id); 
     
//       if (response.status === 200) {
//         // Assuming 'id' is the variable containing the ID you want to save
//         const id = response.data.id; // Replace 'data.id' with the actual property path containing the ID in the response
//         const mailid =  response.data.mailId //Replace 'data.mailId with the actual property path containing the Email in the response
//         const admin_employee = response.data.admin_employee;
    
//         // Save the ID in local storage
//         localStorage.setItem('userId', id);
    
//          // Save the EMAILID in local storage
//          localStorage.setItem('emailId', mailid);

//           // Save the admin employee id in local storage
//           localStorage.setItem('admin_employee', admin_employee);

        
//         // Redirect the user to the '/home' page
//         history.push('/');
//         setIsLogin(false);
//     }
    
//       console.log('Login successful!');
//       // Handle success scenario as needed
//     } catch (error) {
//       console.error('Error:', error);
//       if (error.response && error.response.status === 401) {
//         // Show the Swal alert for a Bad Request (status code 400)
//         Swal.fire({
//           icon: 'error',
//           title: 'Oops...',
//           text: 'Invalid username or password...',
//           confirmButtonColor: '#007500',
//         });
//         setIsLogin(false);
//       }
//       setIsLogin(false);
//       // Handle error scenario as needed
//     }
//   };

//   const handleGoSuperAdmin = () => {
//     history.push('/admin');
//   }


//   const handleGohome = () => {
//     history.push('/sb-home');
//   }

//   const handleGoToForgotPassword = () => {
//     history.push('/forgot-password');
//     localStorage.setItem("passwordFor","Admin");
//   }


//   const handleGoToEmpForgotPassword = () => {
//     history.push('/forgot-password');
//     localStorage.setItem("passwordFor","Employee");
//   }

//   const toggleTooltip = () => {
//     setTooltipOpen(!tooltipOpen);
//   };


//   const EmpSubmit = async (e) => {
//     e.preventDefault();
//     setIsLogin(true);
  
//     try {
//       const response = await axios.post(`${var_api}/api/employees/signin`, {
//         e_email: email,
//         e_password: password,
//       });
     
//       setUserId(response.data.id); 
     
//       if (response.status === 200) {
//         //Assuming 'id' is the variable containing the ID you want to save
//         const id = response.data.employeeDetails.user_id; // Replace 'data.id' with the actual property path containing the ID in the response
//         const mailid =  response.data.employeeDetails.e_email; //Replace 'data.mailId with the actual property path containing the Email in the response
//         const admin_employee = response.data.employeeDetails.id;
//         const sub_status = response.data.sub_status;
//         const verification_status = response.data.verification_status;
//         const e_role = response.data.employeeDetails.e_role;
//         const e_name = response.data.employeeDetails.e_name;
    
//         // Save the ID in local storage
//         localStorage.setItem('userId', id);
    
//          // Save the EMAILID in local storage
//          localStorage.setItem('empEmailId', mailid);

//          localStorage.setItem('empId', admin_employee);

//           // Save the admin employee id in local storage
//           // localStorage.setItem('admin_employee', admin_employee);
//           localStorage.setItem('sub_status', sub_status);
//           localStorage.setItem('verification_status',verification_status)
//           localStorage.setItem('e_role',e_role);
//           localStorage.setItem('empName',e_name);
//           const sub_statusl = localStorage.getItem("sub_status");
//           const verification_statusl = localStorage.getItem("verification_status");
//           console.log("s,v",sub_statusl,verification_statusl);

        
//         // Redirect the user to the '/home' page
//         history.push('/');
//         setIsLogin(false);
//     }
    
//       console.log('Login successful!');
//       // Handle success scenario as needed
//     } catch (error) {
//       console.error('Error:', error);
//       if (error.response && error.response.status === 401) {
//         // Show the Swal alert for a Bad Request (status code 400)
//         Swal.fire({
//           icon: 'error',
//           title: 'Oops...',
//           text: 'Invalid username or password...',
//           confirmButtonColor: '#007500',
//         });
//         setIsLogin(false);
//       }
//       setIsLogin(false);
//       // Handle error scenario as needed
//     }
//   }
  
//   return (
//     <>
//    <div className="auth-wrapper">
//           <div className="auth-inner">
//           <form>
//             <div className="text-center">
//             <img src={sage} alt="logo" style={{width:"100px", height:"100px",border:"3px solid rgba(103,120,95,1)", borderRadius:"50px", padding:"5px"}} />
//             </div>
//         <h3 className="mt-3">Sign In</h3>
//         <div className="mb-3">
//           <label>Email address</label>
//           <input
//             type="email"
//             className="form-control"
//             placeholder="Enter email"
//           />
//         </div>
//         <div className="mb-3">
//           <label>Password</label>
//           <input
//             type="password"
//             className="form-control"
//             placeholder="Enter password"
//           />
//         </div>
//         <div className="mb-3">
//           <div className="custom-control custom-checkbox">
//           <p className="forgot-password text-right fw-bold">
//           Forgot <a href="/admin-forgot-password" style={{color:"rgba(103,120,95,1)",fontWeight:"bolder"}}>password?</a>
//         </p>
//           </div>
//         </div>
//         <div className="d-grid">
//           <button type="submit" className="btn btn-primary" style={{backgroundColor:"rgba(103,120,95,1)", borderColor:"rgba(103,120,95,1)"}} onClick={handleGohome}>
//             Submit
//           </button>
//         </div>
       
//       </form>
//           </div>
//         </div>
//     </>
//   );
// };

// export default SignIn;


